import { initializeApp } from 'firebase/app';
import { 
    getAuth, 
    GoogleAuthProvider, 
    signInWithPopup, 
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signOut, 
    onAuthStateChanged, 
    User 
} from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Configuração do Firebase usando variáveis de ambiente
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Validar configuração
if (!firebaseConfig.apiKey || !firebaseConfig.authDomain || !firebaseConfig.projectId) {
    throw new Error('Configuração do Firebase incompleta. Verifique as variáveis de ambiente.');
}

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar Analytics (opcional)
let analytics;
try {
    analytics = getAnalytics(app);
} catch (error) {
    console.log('Analytics não disponível:', error);
}

// Inicializar Auth
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Configurar provedor Google
googleProvider.setCustomParameters({
    prompt: 'select_account'
});

// Função para login com Google
export const signInWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);
        return result.user;
    } catch (error) {
        console.error('Erro no login com Google:', error);
        throw error;
    }
};

// Função para login com email/senha
export const signInWithEmail = async (email: string, password: string) => {
    try {
        const result = await signInWithEmailAndPassword(auth, email, password);
        return result.user;
    } catch (error) {
        console.error('Erro no login com email:', error);
        throw error;
    }
};

// Função para criar usuário com email/senha
export const createUserWithEmail = async (email: string, password: string) => {
    try {
        const result = await createUserWithEmailAndPassword(auth, email, password);
        return result.user;
    } catch (error) {
        console.error('Erro ao criar usuário:', error);
        throw error;
    }
};

// Função para logout
export const signOutUser = async () => {
    try {
        await signOut(auth);
    } catch (error) {
        console.error('Erro no logout:', error);
        throw error;
    }
};

// Função para observar mudanças de autenticação
export const onAuthStateChange = (callback: (user: User | null) => void) => {
    return onAuthStateChanged(auth, callback);
};

export { analytics };
export default app; 